import './App.css'
import Cell from './cell/Cell'
import { useEffect, useState } from "react"

function App() {
  const [start, setStart] = useState(true)
  const [player, setPlayer] = useState("circle")
  const [cell, setCell] = useState(["", "", "", "", "", "", "", "", ""])
  const [winner, setWinner] = useState(null)
  const [wait, setWait] = useState(null)

  const handleChange = (e, index) => {
    const clicked = e.target.classList.contains("circle") || e.target.classList.contains("cross")
    const cellChange = (className) => {
      let cellC = cell.map((cell, id) => {
          if (index === id) {
              return className
          }else{
              return cell
          }
        })
        setCell(cellC)
  }
    if (!clicked) {
      if (player === "circle") {
        e.target.classList.add("circle")
        cellChange("circle")
        setPlayer("cross")
      }else{
        e.target.classList.add("cross")
        cellChange("cross")
        setPlayer("circle")
      }
    }
    setStart(false)
  }

  let checkWinner = () => {
    let win = [[0,1,2], [3,4,5], [6,7,8], [0,3,6], [1,4,7], [2,5,8], [0,4,8], [2,4,6]]
    win.forEach(array => {
      let circle = array.every(i => cell[i] === "circle")
      if (circle) {
        setWinner("Circle")
      }else{
        // setWinner("draw")
      }
    })
    win.forEach(array  => {
      let cross = array.every(i => cell[i] === "cross")
      if (cross) {
        setWinner("Cross")
      }else{
        // setWinner("draw")
      }
    })
  }

  useEffect(() => {
    checkWinner()
  }, [cell])

  useEffect(() => {
    if (winner) {
      setWait(3)
      setTimeout(() => {
        window.location.reload()
      }, 3000)
    }
  }, [winner])
  return (
    <div className="App">
      {start && <h1 className='begin'>Tap on a tile to begin!!</h1>}
      <div className="board">
        {cell.map((cell, index) => <Cell cell={cell} index={index} key={index} winner={winner} handleChange={handleChange}/>)}
      </div>
      {!winner ? <h1 className='turn'>It's <span>{player}'s</span> turn</h1> : <h1 className='winner'><span>{winner}</span> wins this round</h1>}
      {wait && <h1 className='wait'>Game restarts in <span>{wait}</span> seconds</h1>}
    </div> 
  );
}

export default App;
